var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tree-content-div"},_vm._l((_vm.stateTree),function(item,i){return _c('tree-node',{key:i,attrs:{"data":item,"show-checkbox":_vm.showCheckbox}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }